const name = 'circle-o';

const contents = '<path d="M31 26.5c2.265 0 4.184.373 5.759 1.119 1.574.745 2.858 1.781 3.852 3.107.995 1.325 1.727 2.858 2.196 4.598.47 1.74.704 3.605.704 5.593 0 1.989-.234 3.867-.704 5.634-.47 1.768-1.201 3.315-2.196 4.64-.994 1.326-2.278 2.376-3.852 3.149-1.575.773-3.494 1.16-5.759 1.16s-4.184-.387-5.759-1.16c-1.574-.773-2.858-1.823-3.852-3.149-.995-1.325-1.727-2.872-2.196-4.64-.47-1.767-.704-3.645-.704-5.634 0-1.988.234-3.853.704-5.593.47-1.74 1.201-3.273 2.196-4.598.994-1.326 2.278-2.362 3.852-3.107C26.816 26.873 28.735 26.5 31 26.5zm0 4.64c-2.541 0-4.322.911-5.344 2.734-1.022 1.823-1.533 4.17-1.533 7.043s.51 5.248 1.533 7.126C26.678 49.92 28.459 50.86 31 50.86c2.541 0 4.322-.939 5.344-2.817 1.022-1.878 1.533-4.253 1.533-7.126 0-2.872-.51-5.22-1.533-7.043-1.022-1.823-2.803-2.734-5.344-2.734z" fill="#FFF"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'O',
};

export default icon;
